import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const section = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
});

export const sectionHeading = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
  margin: 0,
});

export const text = css({
  fontSize: 'body',
  color: 'text.subtle',
  lineHeight: 'body',
  margin: 0,
  whiteSpace: 'pre-wrap',
});
